<script lang="ts" setup>
import { useSdk } from '~/sdk';
import { Swiper, SwiperSlide } from 'swiper/vue';
import { Navigation, Pagination } from 'swiper/modules';

const props = defineProps<{
  id: string;
  uid: string;
  title: string;
  slug: string;
  body: string;
  categories: { title: string; slug: string; uri: string; }[];
}>();

const localePath = useLocalePath();

const state = useState<{
  products: any[];
  loading: boolean;
  error: any;
}>(props.uid, () => ({
  products: [],
  loading: false,
  error: null,
}));

async function fetch() {
  state.value.loading = true;
  state.value.error = null;

  const res = await useSdk().commerce.search({
    s: '',
    page: 1,
    facets: { categories: [props.categories[0]?.slug ?? ''] }
  });

  if (res.products) {
    state.value.products = res.products;
  }

  state.value.loading = false;
}

await fetch();
</script>

<template>
  <VContainer>
    <VSection>
      <h2 class="text-2xl mb-6 font-bold text-gray-900">
        {{ title }}
      </h2>
      <div v-if="body" v-html="body" class="prose text-gray-900 max-w-none mb-10" />
      <Swiper :breakpoints="{
        640: {
          slidesPerView: 1,
        },
        768: {
          slidesPerView: 2,
        },
        1024: {
          slidesPerView: 3,
        },
        1280: {
          slidesPerView: 4,
        },
      }" :space-between="20" navigation :pagination="{ clickable: true }" :modules="[Navigation, Pagination]"
        class="pb-10!">
        <SwiperSlide v-for="product in state.products" :key="product.id">
          <VProductCard :product="product" :title="product.name" :image="getPsImage(product.primaryImage)" />
        </SwiperSlide>
      </Swiper>
      <div class="flex justify-end">
        <NuxtLink class="btn btn-secondary inline-flex gap-2"  :to="localePath(`/${props.categories[0]?.uri}`)">
          <span>{{ $t('View all') }}</span>
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6">
            <path stroke-linecap="round" stroke-linejoin="round" d="M17.25 8.25 21 12m0 0-3.75 3.75M21 12H3" />
          </svg>
        </NuxtLink>
      </div>
    </VSection>
  </VContainer>
</template>
